import Vue from 'vue'
import Vuex from 'vuex'
// import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: '',
    userInfo: null,
    userHouseListCurrentCommunity: null,
    consoleInfo: 'vuex'
  },
  getters: {
    getToken(state) {
      return state.token
    },
    getUserInfo(state) {
      if (!state.userInfo) {
        // state.userInfo = JSON.parse(localStorage.getItem('user'))
      } else {
        return state.userInfo
      }
    },
    getUserHouseListCurrentCommunity(state) {
      if (!state.userHouseListCurrentCommunity) {
        // state.userHouseListCurrentCommunity = JSON.parse(localStorage.getItem('userHouseListCurrentCommunity'))
      } else {
        return state.userHouseListCurrentCommunity
      }
    },
    getConsoleInfo(state) {
      return state.consoleInfo
    }
  },
  mutations: {
    setToken(state, token) {
      state.token = token
      // localStorage.setItem('token', token)
    },
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo
      // localStorage.setItem('user', JSON.stringify(userInfo))
    },
    setUserHouseListCurrentCommunity(state, userHouseListCurrentCommunity) {
      state.userHouseListCurrentCommunity = userHouseListCurrentCommunity
      // localStorage.setItem('userHouseListCurrentCommunity', JSON.stringify(userHouseListCurrentCommunity))
    },
    setConsoleInfo(state, consoleInfo) {
      state.consoleInfo = consoleInfo
    }
    // 退出登录时要清楚token和用户信息
    // clearToken(state) {
    //   state.token = ''
    //   state.userInfo = null
    //   localStorage.removeItem('token')
    //   localStorage.removeItem('user')
    // }
  },
  actions: {
    // ???action呢
  }
  // plugins: [createPersistedState()]
})
